module.exports = __webpack_public_path__ + "static/media/blue-loader.c43ca90c.svg";